import type { ArtworkStatusCodeResponse } from "@hops/sdk/types";
import { useState } from "react";

interface StatusUpdateDialogProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (statusCode: string, note: string) => void | Promise<void>;
  statusCodes: ArtworkStatusCodeResponse[];
  currentStatusCode?: string | null;
  isLoading?: boolean;
}

export function StatusUpdateDialog({
  open,
  onClose,
  onSubmit,
  statusCodes,
  currentStatusCode,
  isLoading,
}: StatusUpdateDialogProps) {
  const [statusCode, setStatusCode] = useState("");
  const [note, setNote] = useState("");

  if (!open) return null;

  const handleSubmit = () => {
    if (!statusCode) return;
    onSubmit(statusCode, note);
  };

  const handleClose = () => {
    setStatusCode("");
    setNote("");
    onClose();
  };

  return (
    <div className="hops-overlay" onClick={handleClose}>
      <div className="hops-dialog" onClick={(e) => e.stopPropagation()}>
        <div className="hops-dialog-title">Update Status</div>

        <div className="hops-field">
          <label className="hops-label">New Status</label>
          <select
            className="hops-select"
            value={statusCode}
            onChange={(e) => setStatusCode(e.target.value)}
          >
            <option value="">Select status...</option>
            {statusCodes
              .filter((sc) => sc.code !== currentStatusCode)
              .map((sc) => (
                <option key={sc.code} value={sc.code ?? ""}>
                  {sc.description ?? sc.code}
                </option>
              ))}
          </select>
        </div>

        <div className="hops-field">
          <label className="hops-label">Note (optional)</label>
          <textarea
            className="hops-textarea"
            value={note}
            onChange={(e) => setNote(e.target.value)}
            placeholder="Add a note..."
            rows={3}
          />
        </div>

        <div className="hops-dialog-actions">
          <button
            className="hops-btn hops-btn-secondary"
            onClick={handleClose}
            disabled={isLoading}
          >
            Cancel
          </button>
          <button
            className="hops-btn hops-btn-primary"
            onClick={handleSubmit}
            disabled={!statusCode || isLoading}
          >
            {isLoading ? "Updating..." : "Update"}
          </button>
        </div>
      </div>
    </div>
  );
}
